import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Book } from 'components/Layout';
import DateRangePickerForm, { DateRange } from 'components/Input/components/DateRangePickerForm';
import moment from 'moment';
import { LocationInspectionOrderedDataResponse } from 'types/reporting.type';
import LrGrid from 'components/LrGrid/components/Grid';
import { columnDefs } from './GridDefs';
import { fetchInspectionOrderedData } from 'services/reporting';
import { GridApi } from 'ag-grid-enterprise';

const OrderedInspections: React.FunctionComponent = (props) => {
    const [inspectionData, setInspectionData] = useState<LocationInspectionOrderedDataResponse[]>();
    const [gridApi, setGridApi] = useState<GridApi>();
    const defaultStart = moment().subtract(1, 'week').startOf('week');
    const defaultEnd = moment().subtract(1, 'week').endOf('week');

    const fetchOrderedInspectionData = async (values: DateRange) => {
        const data = await fetchInspectionOrderedData(values);
        setInspectionData(data);
    };

    useEffect(() => {
        fetchOrderedInspectionData({ startDate: defaultStart, endDate: defaultEnd });
    }, []);

    const renderDataGrid = (height: string) => (
        <LrGrid
            gridClassName="ag-theme-balham"
            columnDefs={columnDefs}
            rowData={inspectionData}
            hideStatusBar
            sizeToFit
            rowSelection={'multiple'}
            suppressRowClickSelection={true}
            height={height}
            setGridApi={setGridApi}
        />
    );

    return (
        <>
            <Book>
                <>
                    <Grid container spacing={1}>
                        <Grid xs={12}>
                            <DateRangePickerForm
                                onSubmit={fetchOrderedInspectionData}
                                submitText={'Fetch'}
                                defaultStart={defaultStart}
                                defaultEnd={defaultEnd}
                            />
                        </Grid>
                        <Grid xs={12}>{renderDataGrid('700px')}</Grid>
                    </Grid>
                </>
            </Book>
        </>
    );
};

export default OrderedInspections;
